"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToolsV2 = void 0;

var _preact = require("preact");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _CopyToClipboard = _interopRequireDefault(require("@insided/control/uikit/CopyToClipboard"));

function Tools(props) {
  var fields = props.fields;
  return (0, _preact.h)("div", {
    className: "data-lake-input-wrapper"
  }, fields.map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return value && (0, _preact.h)("div", {
      className: "data-lake-input-wrapper",
      key: key
    }, (0, _preact.h)(_InputGroup.default, {
      id: key
    }, (0, _preact.h)("div", {
      className: "athena-params"
    }, (0, _preact.h)("label", null, key), (0, _preact.h)("div", {
      className: "row-flex"
    }, (0, _preact.h)("input", {
      value: value,
      disabled: true,
      type: "text",
      className: "copy-input-athena-params"
    }), (0, _preact.h)("div", {
      className: "copy-to-clipboard-wrapper"
    }, (0, _preact.h)(_CopyToClipboard.default, {
      text: value
    }))))));
  }));
}

var ToolsV2 = function ToolsV2(props) {
  var fields = props.fields,
      appName = props.appName;
  return (0, _preact.h)("div", {
    className: "data-lake-input-wrapper"
  }, Object.entries(fields).map(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return value && (0, _preact.h)("div", {
      className: "data-lake-input-wrapper",
      key: key
    }, (0, _preact.h)(_InputGroup.default, {
      id: key
    }, (0, _preact.h)("div", {
      className: "athena-params"
    }, (0, _preact.h)("label", null, key), (0, _preact.h)("div", {
      className: "row-flex"
    }, (0, _preact.h)("input", {
      value: value,
      disabled: true,
      type: "text",
      className: "copy-input-athena-params"
    }), (0, _preact.h)("div", {
      className: "copy-to-clipboard-wrapper"
    }, (0, _preact.h)(_CopyToClipboard.default, {
      text: value
    })))), appName === 'S3' && key === 'S3 Path' && (0, _preact.h)("div", {
      className: "athena-params-note"
    }, "Please substitute <model name> with the corresponding model name from the", ' ', (0, _preact.h)("a", {
      href: "https://communities.gainsight.com/data-catalog-connectors-313",
      target: "_blank",
      rel: "noreferrer"
    }, "Data Catalog"), ".")));
  }));
};

exports.ToolsV2 = ToolsV2;
var _default = Tools;
exports.default = _default;